
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/services/ai-chat-assistant",
      function () {
        return require("private-next-pages/services/ai-chat-assistant.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/services/ai-chat-assistant"])
      });
    }
  